"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var curation_actions_1 = require("../actions/curation_actions");
var curation_store_1 = require("../stores/curation_store");
var admin_1 = require("./admin");
var modal_dialog_1 = require("@reverbdotcom/commons/dist/components/modal_dialog");
var CurationModal = /** @class */ (function (_super) {
    tslib_1.__extends(CurationModal, _super);
    function CurationModal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = curation_store_1.default.getState();
        _this.onCurationStoreUpdated = _this.onCurationStoreUpdated.bind(_this);
        return _this;
    }
    CurationModal.prototype.componentDidMount = function () {
        curation_store_1.default.listen(this.onCurationStoreUpdated);
    };
    CurationModal.prototype.componentWillUnmount = function () {
        curation_store_1.default.unlisten(this.onCurationStoreUpdated);
    };
    CurationModal.prototype.onCurationStoreUpdated = function () {
        this.setState(curation_store_1.default.getState());
    };
    CurationModal.prototype.render = function () {
        return (React.createElement(modal_dialog_1.default, { isOpen: this.state.isCurating, contentLabel: "Modal", size: "wide", onSubmit: curation_actions_1.default.stopCurating, saveButtonText: I18n.t('discovery.curation.doneCurating'), headerTitle: I18n.t('discovery.curation.addToSet') },
            React.createElement(admin_1.default, null)));
    };
    return CurationModal;
}(React.Component));
exports.default = CurationModal;
//# sourceMappingURL=modal.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/curation/modal.js
// module id = 4YAm
// module chunks = 20 21